/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import { AppBar, makeStyles, Tabs, Tab } from '@material-ui/core';
import React, { useEffect, useState, useCallback, useRef} from 'react';
import { Dropdown, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import _ from 'lodash';
import SVGComponent from '../../../../../SharedModules/SVGComponents/SVGComponents';
import { getExistingCommentLinkIds } from '../../../../../SharedModules/utilities/commonAPI';
import { naviagteToNDCDetailsPageAction } from '../../../../Display/NDC/store/action';
import {
  // getAccRecNDCSingleRec,
  setSelectedClaimFilterNu,
  setSelectedClaimModeNu,
  setTableDataNu,
  setToggleDisputeResolution,
} from '../../store/action';
import { resolveDisputeResolutionToggle } from '../../../../Display/Claim/utils/constant';
import { SelectedClaimTab } from '../../utils/constant';
import SelectedClaimDrugContainer from './SelectedClaimDrugContainer';
import SelectedClaimInvoiceIndicator from './SelectedClaimInvoiceIndicator';
import SelectedClaimModeContainer from './SelectedClaimModeContainer';
import SelectedClaimSpecialCondition from './SelectedClaimSpecialCondition';
import SelectedClaimsTable from './SelectedClaimsTable';
import DisputeResolutionCheckbox from './DisputeResolutionCheckbox';
import {
  handleQuarterFormate,
  redirectURLLink,
} from '../../../../../SharedModules/CommonUtilities/commonUtilities';
import { getInvoiceHeader } from '../../../../Tasks/AllocatePayments/PQASTab/store/Actions';
import { getAccRecNDCSingleDetail } from '../../../../Research/AccountReceivable/QtrAccountsRec/store/actions';
import {
  ndcDetailFirstLoadAction,
  ndcDetailSingle,
} from '../../../../Research/AccountReceivable/AccRecNDCDetail/store/actions';
import {
  FAIL_PROCESSING_REQUEST,
  NO_DATA,
} from '../../../../../SharedModules/Errors/constantMessageData';
import { goToArSummaryAccRecNDCSingle } from '../../../../Research/AccountReceivable/ARCommonFunctions';
import { checkActionAccessByRole } from '../../../../../SharedModules/utilities/utilities';
import { getInvoiceStatusCd } from '../../../../Display/Claim/store/action';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
  input: {
    color: 'red !important',
  },
}));

const Action = ({ data, setErrorMessage, setSuccessMessages,successMessages}) => {
  const selectedClaim = useSelector(
    (state) => state.sharedState.NumberOfUnits.selectedClaimNu
  );
  const tableData = useSelector(
    (state) => state.sharedState.NumberOfUnits.tableDataNu
  );
  const getSingleAccRecNDCList = useSelector(
    (state) =>
      state?.sharedState?.QtrAccountsRecReducer?.getSingleAccRecNDCList
        ?.acctRecvMfgNDCDetaillSingleServiceResonse
        ?.acctRecvMfgNDCDetailSingleRpcResponseVO[0].status
  );
  const dispatch = useDispatch();
  const history = useHistory();

  const navigateToNDCPage = () => {
    const updateTabs =
      JSON.parse(localStorage.getItem('tabItemsData')) == null
        ? []
        : JSON.parse(localStorage.getItem('tabItemsData'));
    if (updateTabs.findIndex((item) => item.navTo === '/ndc-details') === -1) {
      updateTabs.push({
        navTo: '/ndc-details',
        value: 'NDC Details',
      });
      localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
    }

    history.push({
      pathname: '/ndc-details',
    });
  };

  const handleGoToAccRecNDCDetail = async () => {
    if(successMessages){
      setSuccessMessages([])
     }
    const isPaidQtrToFormat = tableData[0]?.paidQtr;
    const isPaidQtr = handleQuarterFormate(isPaidQtrToFormat);
    const payload_inv = {
      isPrevQTR: isPaidQtr,
      isProgramCode: tableData[0]?.rebateProgramCd,
      isMFG: tableData[0]?.labelerCode,
    };
    try {
      const result = await dispatch(getInvoiceHeader(payload_inv));
      let invoiceNumber;
      let invoiceDate;
      if (
        result &&
        result?.payload &&
        result?.payload?.postInitByInvoiceHeaderResp.length > 0
      ) {
        invoiceNumber =
          result?.payload?.postInitByInvoiceHeaderResp[0]?.idecPrevInvoiceNum;
        invoiceDate =
          result?.payload?.postInitByInvoiceHeaderResp[0]?.idtPrevInvDate;

        const payload = {
          mfgId: tableData[0]?.drugVO?.labelerCode,
          startQuarter: isPaidQtr,
          aiUseOfficialURA: '1',
          invoiceNumber: invoiceNumber,
          rebateProgramCd: tableData[0]?.rebateProgramCd,
        };
        let response = await dispatch(
          getInvoiceStatusCd({ invoiceNum: invoiceNumber })
        );
        const obj = {
          mfgId: tableData[0]?.drugVO?.labelerCode,
          mfgName: tableData[0]?.labelerName,
          getQuarterValue: isPaidQtr,
          pgmInfo: tableData[0]?.rebateProgramCd,
          uraInfo: 'Official',
          invoiceStatus: response?.data?.invoiceStatusCd,
          invoiceStatusCd: response?.data?.invoiceStatusCd,
          invoiceNum: invoiceNumber,
          invoiceDate: invoiceDate,
          pgmCd: tableData[0]?.rebateProgramCd,
        };
        const accountRecResponse = await dispatch(
          getAccRecNDCSingleDetail(payload)
        );
        await dispatch(ndcDetailSingle(obj));

        if (!_.isEmpty(accountRecResponse)) {
          dispatch(ndcDetailFirstLoadAction(false));
          goToArSummaryAccRecNDCSingle(
            history,
            tableData[0]?.rebateProgramCd,
            dispatch
          );
        }
      } else {
        // console.error('Invalid API response structure.');
        dispatch(setErrorMessage([NO_DATA]));
      }
    } catch (error) {
      // console.error('Invalid API response.');
      dispatch(setErrorMessage([NO_DATA]));
    }
  };

  return data ? (
    <Dropdown className="icon-dropdown-container">
      <Dropdown.Toggle
        variant="primary"
        className="icon-dropdown py-0 ml-0"
        aria-label="Action Dropdown"
      >
        <SVGComponent iconName="Export-icon" />
      </Dropdown.Toggle>
      <Dropdown.Menu>
        <Dropdown.Item
          role="button"
          onClick={() => {
            handleGoToAccRecNDCDetail();
          }}
        >
          Go to Accounts Receivable NDC detail
        </Dropdown.Item>
        <Dropdown.Item
          role="button"
          onClick={() => {
            dispatch(
              naviagteToNDCDetailsPageAction({
                succesFunc: () => {
                  navigateToNDCPage();
                },
                ndcDetailsTableData: [
                  {
                    ndc: data && data.drugVO && data.drugVO.ndc,
                    drugName: data && data.drugVO && data.drugVO.drugName,
                  },
                ],
              })
            );
          }}
        >
          Go to NDC
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  ) : (
    <></>
  );
};

const SelectedClaimTabContainer = ({
  fullScreen,
  setFullScreen,
  data,
  currentIndex,
  claimReferenceData,
  systemParameter,
  tableFullScreen,
  setTableFullScreen,
  claimSelectByFilter,
  setStateChange,
  setErrorMessage,
  setSuccessMessages,
  successMessages,
  disableBtn,
  setBeforeSaveModeVal,
  handleOpenSave,
}) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const applyUserDefaultDisputeToggleRef = useRef(true);

  // const [tableData, setTableData] = useState([]);
  const [specialConditionExists, setSpecialConditionExists] = useState(false);
  const [tabSelected, setTabSelected] = useState(SelectedClaimTab[1].value);
  const selectedClaimModeNu = useSelector(
    (state) => state.sharedState.NumberOfUnits.selectedClaimModeNu
  );
  const [hasAccess, setHasAccess] = useState(
    checkActionAccessByRole(process.env.REACT_APP_HIDE_ACCESS_ROLES, kcRoles)
  );
  const [isEnablebyRole, setIsEnablebyRole] = useState(
    checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
  );

  const history = useHistory();
  const selectedClaimFilter = useSelector(
    (state) => state.sharedState.NumberOfUnits.selectedClaimFilterNu
  );

  const tableData = useSelector(
    (state) => state.sharedState.NumberOfUnits.tableDataNu
  );
  const selectBy = useSelector(
    (state) => state.sharedState.NumberOfUnits.selectBy
  );
  const userDefaults = useSelector(
    (state) => state.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );
  const { kcRoles } = useSelector((state) => state.sharedState.SharedReducer);
  useEffect(() => {
    if (kcRoles?.userPrivileges.length > 0) {
      setHasAccess(
        checkActionAccessByRole(
          process.env.REACT_APP_HIDE_ACCESS_ROLES,
          kcRoles
        )
      );
      setIsEnablebyRole(
        checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
      );
    }
  }, []);
  useEffect(() => {
    if (!selectedClaimFilter) {
      if (
        data &&
        data[currentIndex] &&
        data[currentIndex].claimResultVOList &&
        data[currentIndex].claimResultVOList.length > 0
      ) {
        const filterInvoice = data[currentIndex].claimResultVOList.filter(
          (item) => item.invoicedInd === 1
        );

        const filterNonInvoice = data[currentIndex].claimResultVOList.filter(
          (item) => item.invoicedInd !== 1
        );

        dispatch(
          setSelectedClaimFilterNu({
            ...selectedClaimFilter,
            invoiceSelected: {
              invoiced: filterInvoice.length > 0,
              nonInvoiced: filterNonInvoice.length > 0,
            },
          })
        );
      }
    }
  }, []);
  useEffect(() => {
    applyUserDefaultDisputeToggleRef.current = true;
  }, [currentIndex, data && data[currentIndex]]);
  useEffect(() => {
    getData();
    // window.getData = getData;
  }, [
    data && data[currentIndex],
    selectedClaimFilter && selectedClaimFilter.invoiceSelected,
  ]);
  const getData = () => {
    getExistingCommentLinkIds(
      data[currentIndex]?.claimResultVOList
        ?.filter((item) => item.corrLinkId)
        .map((item) => item.corrLinkId)
    )
      .then((existingCommentIdList) => {
        const updatedData = data[currentIndex]?.claimResultVOList?.map(
          (item) => ({
            ...item,
            ccCommentsExist: existingCommentIdList.includes(item.corrLinkId)
              ? 1
              : 0,
          })
        );
        let tableRows = [];
        if (
          data?.length > 0 &&
          updatedData?.length > 0 &&
          selectedClaimFilter?.invoiceSelected
        ) {
          if (
            (!selectedClaimFilter?.invoiceSelected?.invoiced &&
              !selectedClaimFilter?.invoiceSelected?.nonInvoiced) ||
            (selectedClaimFilter?.invoiceSelected?.invoiced &&
              selectedClaimFilter?.invoiceSelected?.nonInvoiced)
          ) {
            tableRows = updatedData;
          } else if (
            selectedClaimFilter.invoiceSelected.invoiced &&
            !selectedClaimFilter.invoiceSelected.nonInvoiced
          ) {
            tableRows = updatedData.filter((item) => item.invoicedInd === 1);
          } else if (
            !selectedClaimFilter.invoiceSelected.invoiced &&
            selectedClaimFilter.invoiceSelected.nonInvoiced
          ) {
            tableRows = updatedData.filter((item) => item.invoicedInd !== 1);
          }
        } else if (selectBy === 'claimId') {
          tableRows = updatedData || [];
        }
        dispatch(setTableDataNu(tableRows));
        const isPageLoad = applyUserDefaultDisputeToggleRef.current;
        if (isPageLoad) {
          applyUserDefaultDisputeToggleRef.current = false;
        }
        dispatch(
          setToggleDisputeResolution(
            resolveDisputeResolutionToggle({
              isPageLoad,
              userDefaults,
              tableRows,
            })
          )
        );
      })
      .catch((err) => {});
  };
  useEffect(() => {
    if (tableData && tableData.length > 0) {
      const arr = ['DB', 'WO', 'FG', 'DBK'];

      const filterArr = tableData.filter(
        (item) =>
          (item.drugStatus && arr.includes(item.drugStatus)) ||
          (item.unitsModFromArInd !== null && item.unitsModFromArInd > 0)
      );
      if (filterArr.length > 0) {
        setSpecialConditionExists(true);
      } else {
        setSpecialConditionExists(false);
      }
    } else {
      setSpecialConditionExists(false);
    }
  }, [tableData]);
  return (
    <>
      {!tableFullScreen && (
        <div className="tabs-wrapper d-flex justify-content-between col-12">
          <div className={classes.root}>
            <AppBar position="static" sx={{ width: '100%' }}>
              <Tabs
                value={tabSelected}
                onChange={(e, value) =>{     if(successMessages){
                  setSuccessMessages([])
                 }
                  setTabSelected(value)}}
                color="red"
                style={{ color: 'red' }}
              >
                {SelectedClaimTab.map((item, index) => (
                  <Tab
                    key={index}
                    tabIndex={0}
                    style={{ textTransform: 'capitalize' }}
                    value={item.value}
                    label={item.label}
                  />
                ))}
              </Tabs>
            </AppBar>
          </div>

          <div className="d-flex align-items-center th-icon-group">
            <Action
              data={
                data &&
                data[currentIndex] &&
                data[currentIndex].claimResultVOList &&
                data[currentIndex].claimResultVOList[0]
              }
              setErrorMessage={setErrorMessage}
              setSuccessMessages={setSuccessMessages}
            />
            <OverlayTrigger
              placement="bottom"
              overlay={
                <Tooltip id="fullScreen-tooltip">
                  {fullScreen ? 'Minimize Screen' : 'Full Screen'}{' '}
                </Tooltip>
              }
            >
              <div
                className={
                  fullScreen
                    ? 'th-icon ic-fulScreen-exit'
                    : 'th-icon ic-fulScreen'
                }
                role="button"
                tabIndex="0"
                data-testid="setFullScreenView"
                onClick={() => {if(successMessages){
                  setSuccessMessages([])
                 }
                   setFullScreen(!fullScreen)}}
              >
                <span className="ic-title">
                  {fullScreen ? 'Minimize Screen' : 'Full Screen'}{' '}
                </span>
              </div>
            </OverlayTrigger>
          </div>
        </div>
      )}
      {tabSelected === SelectedClaimTab[1].value && (
        <>
          {!tableFullScreen && (
            <SelectedClaimInvoiceIndicator
              setSuccessMessages={setSuccessMessages}
              specialConditionExists={specialConditionExists}
              selectedClaimFilter={selectedClaimFilter}
            />
          )}
          {!tableFullScreen && selectedClaimModeNu != 'display' && (
            <DisputeResolutionCheckbox
              setSuccessMessages={setSuccessMessages}
              specialConditionExists={specialConditionExists}
              selectedClaimFilter={selectedClaimFilter}
            />
          )}
          {!tableFullScreen && specialConditionExists && (
            <SelectedClaimSpecialCondition />
          )}

          {!tableFullScreen && (
            <SelectedClaimModeContainer
              specialConditionExists={specialConditionExists}
              selectedClaimModeNu={selectedClaimModeNu}
              _handleClick={(val) => { setSuccessMessages([])
                dispatch(setSelectedClaimModeNu(val));
              }}
              isEnablebyRole={isEnablebyRole}
              disableBtn={disableBtn}
              setBeforeSaveModeVal={setBeforeSaveModeVal}
              handleOpenSave={() => {
                handleOpenSave();
              }}
            />
          )}
          <SelectedClaimsTable
            tableData={tableData}
            setSuccessMessages={setSuccessMessages}
            claimReferenceData={claimReferenceData}
            tableFullScreen={tableFullScreen}
            setTableFullScreen={setTableFullScreen}
            systemParameter={systemParameter}
            claimSelectByFilter={claimSelectByFilter}
            setStateChange={setStateChange}
            hasAccess={hasAccess}
            isEnablebyRole={isEnablebyRole}
          />
        </>
      )}
      {tabSelected === SelectedClaimTab[0].value && (
        <>
          <SelectedClaimDrugContainer
            selectedClaimFilter={selectedClaimFilter}
            data={
              data &&
              data[currentIndex] &&
              data[currentIndex].claimResultVOList &&
              data[currentIndex].claimResultVOList[0]
            }
            claimReferenceData={claimReferenceData}
          />
        </>
      )}
    </>
  );
};

export default SelectedClaimTabContainer;
